import { render, staticRenderFns } from "./SplitInvoiceModal.vue?vue&type=template&id=72e3f356"
import script from "./SplitInvoiceModal.vue?vue&type=script&lang=js"
export * from "./SplitInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./SplitInvoiceModal.vue?vue&type=style&index=0&id=72e3f356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports